var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenExclamationMarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.896,
    height: 16.896,
    viewBox: "0 0 16.896 16.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info_Circle",
    "data-name": "Info Circle",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M7.7,0A7.7,7.7,0,1,1,0,7.7,7.7,7.7,0,0,1,7.7,0Z",
    transform: "translate(0.75 0.75)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M.5,0V3.677",
    transform: "translate(7.944 5.289)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M.5.5H.5",
    transform: "translate(7.949 11.107)",
    fill: "none",
    stroke: "#199b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenExclamationMarkIcon);
export default __webpack_public_path__ + "static/media/green-exclamation-mark-icon.5a96a4fa7dac0755fe6158074093a7c1.svg";
export { ForwardRef as ReactComponent };